import React, {useState, useEffect, useContext} from 'react'

import {ApiServiceContext} from '../context'

const withCategory = WrappedComponent => {
  return (props) => {
    const all = 'Все';
    const {categoryId} = props;

    const apiService = useContext(ApiServiceContext);
    const
      [categoryTitle, setCategoryTitle] = useState(all),
      [categoryList, setCategoryList] = useState([]);

    useEffect(() => {
      let mounted = true;

      apiService.getCategories()
        .then(({data}) => {
          if (mounted && data) {
            if (categoryId) {
              const newCategoryTitle = data.filter(({id}) => id === parseInt(categoryId))[0].title;
              setCategoryTitle(newCategoryTitle)
            }

            setCategoryList(data)
          }
        })
        .catch(console.error);

      if (categoryId === 0) {
        setCategoryTitle('Результаты поиска')
      }

      return () => {
        mounted = false
      }
    }, [categoryId]);

    return (
      <WrappedComponent {...props} categoryTitle={categoryTitle} categoryList={categoryList}/>
    )
  }
};

export default withCategory;
